module.exports = __webpack_public_path__ + "2cf52b9edfe13451bb7049719c9e8898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/comment-black.png
// module id = 208
// module chunks = 0